// Importing the database service and Dexie library
import { reportError, toErrorString } from "../utils/errorLogger";
import db from "./db-service";
import Dexie from 'dexie';

// Function to return email records from the database
export const returnEmailRecords = async () => {
    try {
        // Retrieving all records from the "emails" table
        let tableValue = await db.table("emails").toArray();
        return tableValue;
    } catch (error) {
        const userName = localStorage.getItem('UserName');
        const errorStr = toErrorString(error || error.message);
        reportError({
            endpoint: '-',
            message: `FileName: dbhelper.js, Fun: returnEmailRecords, ${String(error.message || 'Unhandled error')}`,
            error: errorStr,
            userName: userName || '',
        });
        // Returning an empty array if there's an error
        return [];
    }
}

// Function to delete the entire database
//
// AWAITS the deletion rather than firing it off. The cache now survives sign-in for the same user
// (routes/SignIn.js), so the wipe only runs on a real account switch or logout — exactly the cases where
// letting it run in the background is unsafe: the delete could land AFTER the next account had started
// writing, silently destroying the new user's cache, or the old user's rows could still be readable
// while the new session is already up. Callers that don't await behave as before.
export const deleteDatabase = async () => {
    try {
        // Using Dexie's delete method to delete the database
        await Dexie.delete('web3Dmails');
        // Logging success message if database is deleted successfully
        console.log("Database deleted successfully.");
        return true;
    } catch (err) {
        // Logging error message if there's an error deleting the database
        console.error("Error deleting database:", err);
        const userName = localStorage.getItem('UserName');
        const errorStr = toErrorString(err || err.message);
        reportError({
            endpoint: '-',
            message: `FileName: dbhelper.js, Fun: deleteDatabase, ${String(err.message || 'Unhandled error')}`,
            error: errorStr,
            userName: userName || '',
        });
        return false;
    }
}


const contactDB = new Dexie("Dcontact");

contactDB.version(1).stores({
    contacts: "id",
    decryptedValue: "id"
})

// Version 2 – added userKeys table
contactDB.version(2).stores({
  contacts: "id",
  decryptedValue: "id",
  userKeys: "userName, symmetricKey",
});

// Version 3 – DROP userKeys. It stored the *unwrapped* contacts DEK in plaintext on disk, where it
// outlived the session: nothing ever read it back, and deleteContacts() tried to remove it with
// .delete("userKeys") when the table's primary key is userName — so the key was never actually
// deleted on logout or account switch. Setting a store to null drops it and its contents, which
// also purges keys already leaked onto existing installs. The DEK now lives only in the
// module-memory cache in src/helper/contactsDek.js.
contactDB.version(3).stores({
  contacts: "id",
  decryptedValue: "id",
  userKeys: null,
});

export async function deleteContacts() {
    await contactDB.contacts.delete("contactList")
    await contactDB.decryptedValue.delete("DecryptedValue")
}
export { contactDB };